const stateTypes = {
  schedule: 'schedule',
  schedules: 'schedules',
  userProfile: 'userProfile',
  regions: 'regions',
  news: 'news',
  oneNews: 'oneNews',
  recommendations: 'recommendations',
  wireOems: 'wireOems',
  logData: 'logdata',
  filterLogData: '',
  notificationSettings: 'notificationSettings'
};

const getterTypes = {
  commonApi: 'commonApiGetter',
  getSchedule: 'getScheduleGetter',
  getSchedules: 'getSchedulesGetter',
  getProfile: 'getProfileGetter',
  getRegions: 'getRegionsGetter',
  getOneNews: 'getOneNewsGetter',
  getAllNews: 'getAllNewsGetter',
  getProfileDateFormat: 'getProfileDateFormatGetter',
  getProfileEstimatedProduction: 'getProfileEstimatedProductionGetter',
  getProfileMetricData: 'getProfileMetricDataGetter',
  getRecommendations: 'getRecommendationsGetter',
  getAcceptedTos: 'getAcceptedTosGetter',
  getLastTosVersion: 'getLastTosVersionGetter',
  getWireOems: 'getWireOemsGetter',
  getLogData: 'getLogDataGetter',
  getLogsHasMore: 'getLogsHasMoreGetter',
  getLogFilterData: 'setLogFilterDataGetter',
  getNotificationSettings: 'getNotificationSettingsGetter'
};

const mutationTypes = {
  setSchedule: 'setScheduleMutation',
  setSchedules: 'setSchedulesMutation',
  setUserProfile: 'setUserProfileMutation',
  updateUserProfile: 'updateUserProfileMutation',
  setOneNews: 'setOneNewsMutation',
  setAllNews: 'setAllNewsMutation',
  setRegions: 'setRegionsMutation',
  setRecommendations: 'setRecommendationsMutation',
  setWireOems: 'setWireOemsMutation',
  setLogData: 'setLogDataMutation',
  setLogFilterData: 'setLogFilterDataMutation',
  setNotificationSettings: 'setNotificationSettingsMutation'
};

const actionTypes = {
  getSchedules: 'getSchedulesAction',
  exportSchedule: 'exportScheduleAction',
  getProfile: 'getProfileAction',
  editProfile: 'editProfileAction',
  uploadProfileImage: 'uploadProfileImageAction',
  getOneNews: 'getOneNewsAction',
  getAllNews: 'getAllNewsAction',
  getRegions: 'getRegionsAction',
  getRecommendations: 'getRecommendationsAction',
  getRecommendationsBySpecification: 'getRacommendationBySpecificationAction',
  addCustomRecommendation: 'addCustomRecommendationAction',
  acceptTos: 'acceptTosAction',
  getWireOems: 'getWireOemsAction',
  setOemFilter: 'setOemFilterAction',
  getLogData: 'getLogDataAction',
  getLogFilterData: 'getLogFilterDataAction',
  getNotificationSettings: 'getNotificationSettingsAction',
  updateNotificationSetting: 'updateNotificationSettingAction'
};

export { stateTypes, getterTypes, mutationTypes, actionTypes };
